import React from 'react';

export default function RegisterKitConfirmDialog({
  selectedKit,
  registeredNameLabel,
  resultsDestinationLabel,
  onBack,
  onConfirm,
  isSubmitting,
  titleId = 'confirm-register-title',
  confirmLabel = 'Ja, kit registreren',
  confirmSubmittingLabel = 'Bezig…',
}) {
  const titleRef = React.useRef(null);

  React.useEffect(() => {
    titleRef.current?.focus();
  }, []);

  if (!selectedKit) return null;

  const descId = `${titleId}-desc`;

  return (
    <section
      role="dialog"
      aria-modal="false"
      aria-labelledby={titleId}
      aria-describedby={descId}
      className="w-full text-left"
    >
      <div className="space-y-3 text-left">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onBack}
            disabled={isSubmitting}
            className="shrink-0 w-8 h-8 rounded-full border border-[#D9E0E6] text-[#64748B] flex items-center justify-center transition-opacity hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Terug naar vorige stap"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M10 3L5 8L10 13"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <h2
            ref={titleRef}
            id={titleId}
            tabIndex={-1}
            className="min-w-0 text-[#1E2426] font-poppins font-semibold text-lg md:text-xl leading-tight outline-none"
          >
            Weet je het zeker?
          </h2>
        </div>
        <p
          id={descId}
          className="text-left text-[#6F7A82] font-poppins text-sm md:text-[14px] leading-6"
        >
          Dit kan niet ongedaan worden gemaakt. Neem contact op met de klantenservice als je een fout
          wilt corrigeren.
        </p>
      </div>

      <div className="mt-6 w-full max-w-xl mx-auto rounded-xl bg-[#F9F5F2] border border-[#E8E2DE] overflow-hidden">
        <div className="px-4 py-3.5 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 sm:gap-4 border-b border-[#E5E7EB]">
          <span className="text-[#6F7A82] font-poppins text-sm shrink-0">Kit</span>
          <span className="text-[#1E2426] font-poppins font-semibold text-sm md:text-[15px] text-right sm:max-w-[70%]">
            {selectedKit.id}
            {selectedKit.name ? ` · ${selectedKit.name}` : ''}
          </span>
        </div>
        <div className="px-4 py-3.5 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 sm:gap-4 border-b border-[#E5E7EB]">
          <span className="text-[#6F7A82] font-poppins text-sm shrink-0">
            Geregistreerd op naam van
          </span>
          <span className="text-[#1E2426] font-poppins font-semibold text-sm md:text-[15px] text-right sm:max-w-[70%] break-words">
            {registeredNameLabel}
          </span>
        </div>
        <div className="px-4 py-3.5 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 sm:gap-4">
          <span className="text-[#6F7A82] font-poppins text-sm shrink-0">Resultaten gaan naar</span>
          <span className="text-[#1C8B6A] font-poppins font-semibold text-sm md:text-[15px] text-right sm:max-w-[70%] break-all">
            {resultsDestinationLabel}
          </span>
        </div>
      </div>

      <div className="mt-6 flex justify-center">
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onConfirm();
          }}
          disabled={isSubmitting}
          className={`w-full sm:w-auto px-8 h-11 md:h-12 rounded-full font-poppins text-base md:text-lg font-medium transition-opacity disabled:cursor-not-allowed ${
            isSubmitting
              ? 'bg-[#C7CFD7] text-white'
              : 'bg-[#119975] text-[#FFFFFF] hover:opacity-95'
          }`}
        >
          {isSubmitting ? confirmSubmittingLabel : confirmLabel}
        </button>
      </div>
    </section>
  );
}
